import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import PortalLayout from '../../components/portal/PortalLayout';
import { clearPortalTokens, staffApi } from '../../lib/http';

const items = [
  { label: 'Dashboard', href: '/staff/dashboard' },
  { label: 'Check-ins', href: '/staff/checkins' },
  { label: 'Profile', href: '/staff/profile' },
  { label: 'Scanner', href: '/staff/scanner' },
];

export default function StaffLayout() {
  const navigate = useNavigate();

  async function logout() {
    try {
      await staffApi.post('/staff/auth/logout');
    } finally {
      clearPortalTokens('staff');
      navigate('/staff/login', { replace: true });
    }
  }

  return (
    <PortalLayout
      title="Staff Portal"
      subtitle=""
      items={items}
      onLogout={logout}
    >
      <Outlet />
    </PortalLayout>
  );
}
